import React from 'react';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  bgColor?: 'white' | 'lightgray' | 'lime';
}
export const Section: React.FC<SectionProps> = ({
  children,
  className = '',
  bgColor = 'white'
}) => {
  const bgClass = bgColor === 'lightgray' ? 'bg-lightgray bg-opacity-30' : bgColor === 'lime' ? 'bg-lime' : 'bg-white';
  return <section className={`py-12 md:py-20 ${bgClass} ${className}`} data-id="element-146" data-mp="cf51k3zfg41c">
      <div className="container mx-auto px-4 md:px-12" data-id="element-147" data-mp="chri2t4aptvp">{children}</div>
    </section>;
};